/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type TotalSellOrdersQueryVariables = Types.Exact<{
	filter: Types.TotalSellOrdersFilter;
}>;

export type TotalSellOrdersQuery = {
	__typename?: "Query";
	totalSellOrders: { __typename?: "TotalSellOrdersResult"; amount: { __typename?: "CurrencyAmount"; value: string } };
};

export const TotalSellOrdersDocument = gql`
	query totalSellOrders($filter: TotalSellOrdersFilter!) {
		totalSellOrders(filter: $filter) {
			amount {
				value
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class TotalSellOrdersGQLService extends Apollo.Query<TotalSellOrdersQuery, TotalSellOrdersQueryVariables> {
	document = TotalSellOrdersDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
